import { render, staticRenderFns } from "./IcoGraphSquare.vue?vue&type=template&id=4e58480d"
import script from "./IcoGraphSquare.vue?vue&type=script&lang=js"
export * from "./IcoGraphSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports